import ExFoldTableCell from './ExFoldTableCell';
ExFoldTableCell.install = (Vue)=>{
    Vue.components(ExFoldTableCell.name,ExFoldTableCell)
}
export default ExFoldTableCell;
